import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=6dfed3a0&scoped=true&"
import script from "./VariantSelector.vue?vue&type=script&lang=js&"
export * from "./VariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./VariantSelector.vue?vue&type=style&index=0&id=6dfed3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfed3a0",
  null
  
)

export default component.exports